import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";

export function travellerGroup (fb: FormBuilder):FormArray {
    return fb.array([
        travellerGroupInArray(fb)
    ]);
}

export function travellerGroupInArray (fb: FormBuilder):FormGroup {
    return fb.group({
        title: ['Mr', Validators.required],
        type: ['Adult', Validators.required],
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        id: [''],
        age: [''],
        // APIS related controls must match those in IdentityInfoEditorComponent.
        birthDate: [''],
        placeOfBirth: [''],
        identityType: null,
        passportCitizenship: [''],
        isReadonly: [''],
        passport: fb.group({
            passNumber: [''],
            validity: fb.group({
                passEnd: ['']
            }),
            issuance: fb.group({
                passCountry: ['']
            })
        }),
        identityCardCitizenship: [''],
        identityCard: fb.group({
            cardNumber: [''],
            validity: fb.group({
                cardEnd: ['']
            }),
            issuance: fb.group({
                cardCountry: ['']
            })
        }),
    });
}
